const MealItemsForm = function(el, opts) {
    this.$el = el instanceof jQuery ? el : $(el);
    this.el = this.$el[0];
    this.options = opts || {};
    this.init();
};

MealItemsForm.prototype = {
    constructor: MealItemsForm,
    $el: undefined,
    modifierTpl: undefined,
    init: function() {
        var self = this;

        if (!self.$el.length || self.$el.attr('data-state') == 'loaded') { return; }
        self.$el.attr('data-state', 'loaded');

        self.modifierTpl = _.template(document.querySelector('#modifier_columns').innerHTML);

        self.el.querySelector('.modifiers-add').addEventListener('click', function() {
            self.addModifierRow();
        });

        self.el.querySelector('.modifiers-table tbody').addEventListener('click', function(evt) {
            var removeBtn = evt.target.classList.contains('remove-btn') ? evt.target : evt.target.closest('.remove-btn');
            if (removeBtn) {
                self.removeModifierRow(removeBtn.closest('tr'));
            }
        });

        // pre-load modifiers
        var mods = JSON.parse(self.el.querySelector('#item_modifiers').innerHTML);
        for (var i = 0; i < mods.length; i++) {
            var row = self.addModifierRow();
            for (var key in mods[i]) {
                if (mods[i].hasOwnProperty(key)) {
                    if (key == 'default') {
                        row.querySelector('[name="modifiers[modifier_' + (i + 1) + '][' + key + ']').checked = mods[i][key] ? true : false;
                    }
                    else {
                        row.querySelector('[name="modifiers[modifier_' + (i + 1) + '][' + key + ']').value = mods[i][key];
                    }
                }
            }
        }
    },
    getModifierRows: function() {
        return this.el.querySelectorAll('.modifiers-table tbody tr');
    },
    addModifierRow: function() {
        var self = this,
            row = document.createElement('tr');
        row.innerHTML = self.modifierTpl({idx: _.uniqueId('modifier_')});
        self.el.querySelector('.modifiers-table tbody').appendChild(row);
        return row;
    },
    removeModifierRow: function(row) {
        var self = this;
        row.remove();
    }
};

module.exports = MealItemsForm;